import { render } from "./EmployeeAutocomplete.vue?vue&type=template&id=08362132&scoped=true"
import script from "./EmployeeAutocomplete.vue?vue&type=script&lang=js"
export * from "./EmployeeAutocomplete.vue?vue&type=script&lang=js"

import "./EmployeeAutocomplete.vue?vue&type=style&index=0&id=08362132&scoped=true&lang=css"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08362132"]])

export default __exports__